import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CategoryContentBodyDynamicZoneInput: any;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** A string used to identify an i18n locale */
  I18NLocaleCode: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  LandingSiteBodyDynamicZoneInput: any;
  PageBodyDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nei?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryContent = {
  __typename?: 'CategoryContent';
  body?: Maybe<Array<Maybe<CategoryContentBodyDynamicZone>>>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<CategoryContentRelationResponseCollection>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CategoryContentLocalizationsArgs = {
  filters?: InputMaybe<CategoryContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CategoryContentBodyDynamicZone = ComponentBasicBlockS1Banner | ComponentBasicBlockS3SingleProduct | ComponentBasicBlockS4ProductList | ComponentSectionsCz10Accordion | ComponentSectionsCz11Cta | ComponentSectionsCz12TextBlock | ComponentSectionsCz13ImageWithText | ComponentSectionsCz14ImageGallery | ComponentSectionsCz15Article | ComponentSectionsCz16Features | ComponentSectionsCzAboutUs | ComponentSectionsS55Form | Error;

export type CategoryContentEntity = {
  __typename?: 'CategoryContentEntity';
  attributes?: Maybe<CategoryContent>;
  id?: Maybe<Scalars['ID']>;
};

export type CategoryContentEntityResponse = {
  __typename?: 'CategoryContentEntityResponse';
  data?: Maybe<CategoryContentEntity>;
};

export type CategoryContentEntityResponseCollection = {
  __typename?: 'CategoryContentEntityResponseCollection';
  data: Array<CategoryContentEntity>;
  meta: ResponseCollectionMeta;
};

export type CategoryContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CategoryContentFiltersInput>>>;
  categoryId?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CategoryContentFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CategoryContentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CategoryContentInput = {
  body?: InputMaybe<Array<Scalars['CategoryContentBodyDynamicZoneInput']>>;
  categoryId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryContentRelationResponseCollection = {
  __typename?: 'CategoryContentRelationResponseCollection';
  data: Array<CategoryContentEntity>;
};

export type ComponentBasicBlockS1Banner = {
  __typename?: 'ComponentBasicBlockS1Banner';
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  customerGroups?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  targetBlank?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentBasicBlockS1BannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBasicBlockS1BannerFiltersInput>>>;
  buttonText?: InputMaybe<StringFilterInput>;
  buttonUrl?: InputMaybe<StringFilterInput>;
  customerGroups?: InputMaybe<JsonFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBasicBlockS1BannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBasicBlockS1BannerFiltersInput>>>;
  targetBlank?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentBasicBlockS1BannerInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  customerGroups?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  targetBlank?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentBasicBlockS3SingleProduct = {
  __typename?: 'ComponentBasicBlockS3SingleProduct';
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  product?: Maybe<Scalars['String']>;
};

export type ComponentBasicBlockS3SingleProductFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBasicBlockS3SingleProductFiltersInput>>>;
  customerGroups?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<ComponentBasicBlockS3SingleProductFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBasicBlockS3SingleProductFiltersInput>>>;
  product?: InputMaybe<StringFilterInput>;
};

export type ComponentBasicBlockS4ProductList = {
  __typename?: 'ComponentBasicBlockS4ProductList';
  Products?: Maybe<Array<Maybe<ComponentBasicBlockS3SingleProduct>>>;
  category?: Maybe<Scalars['String']>;
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
};


export type ComponentBasicBlockS4ProductListProductsArgs = {
  filters?: InputMaybe<ComponentBasicBlockS3SingleProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesAboutItem = {
  __typename?: 'ComponentModulesAboutItem';
  id: Scalars['ID'];
  image?: Maybe<UploadFileRelationResponseCollection>;
  imageAlt?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<UploadFileRelationResponseCollection>;
  imageTitle?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  targetBlank?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentModulesAboutItemImageArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentModulesAboutItemImageMobileArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesAboutItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesAboutItemFiltersInput>>>;
  imageAlt?: InputMaybe<StringFilterInput>;
  imageTitle?: InputMaybe<StringFilterInput>;
  linkUrl?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesAboutItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesAboutItemFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  targetBlank?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesAccordionItem = {
  __typename?: 'ComponentModulesAccordionItem';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ComponentModulesAccordionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesAccordionItemFiltersInput>>>;
  not?: InputMaybe<ComponentModulesAccordionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesAccordionItemFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesCtaItem = {
  __typename?: 'ComponentModulesCtaItem';
  buttonTargetBlank?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  icon?: Maybe<UploadFileEntityResponse>;
  iconAlt?: Maybe<Scalars['String']>;
  iconDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentModulesCtaItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesCtaItemFiltersInput>>>;
  buttonTargetBlank?: InputMaybe<BooleanFilterInput>;
  buttonText?: InputMaybe<StringFilterInput>;
  buttonUrl?: InputMaybe<StringFilterInput>;
  iconAlt?: InputMaybe<StringFilterInput>;
  iconDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesCtaItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesCtaItemFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesFeatItem = {
  __typename?: 'ComponentModulesFeatItem';
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageTitle?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  targetBlank?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentModulesFeatItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesFeatItemFiltersInput>>>;
  imageAlt?: InputMaybe<StringFilterInput>;
  imageTitle?: InputMaybe<StringFilterInput>;
  linkUrl?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesFeatItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesFeatItemFiltersInput>>>;
  targetBlank?: InputMaybe<BooleanFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesFormItem = {
  __typename?: 'ComponentModulesFormItem';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  inputType?: Maybe<Enum_Componentmodulesformitem_Inputtype>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type ComponentModulesFormItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesFormItemFiltersInput>>>;
  displayName?: InputMaybe<StringFilterInput>;
  inputType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesFormItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesFormItemFiltersInput>>>;
  placeholder?: InputMaybe<StringFilterInput>;
  required?: InputMaybe<BooleanFilterInput>;
};

export type ComponentModulesGalleryItem = {
  __typename?: 'ComponentModulesGalleryItem';
  id: Scalars['ID'];
  image: UploadFileEntityResponse;
  imageAlt?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<UploadFileEntityResponse>;
  imageTitle?: Maybe<Scalars['String']>;
  linkTargetBlank?: Maybe<Scalars['Boolean']>;
  linkUrl?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentModulesGalleryItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentModulesGalleryItemFiltersInput>>>;
  imageAlt?: InputMaybe<StringFilterInput>;
  imageTitle?: InputMaybe<StringFilterInput>;
  linkTargetBlank?: InputMaybe<BooleanFilterInput>;
  linkUrl?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesGalleryItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesGalleryItemFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesImageTextItem = {
  __typename?: 'ComponentModulesImageTextItem';
  alignment?: Maybe<Enum_Componentmodulesimagetextitem_Alignment>;
  buttonTargetBlank?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: UploadFileEntityResponse;
  imageAlt?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<UploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentModulesImageTextItemFiltersInput = {
  alignment?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentModulesImageTextItemFiltersInput>>>;
  buttonTargetBlank?: InputMaybe<BooleanFilterInput>;
  buttonText?: InputMaybe<StringFilterInput>;
  buttonUrl?: InputMaybe<StringFilterInput>;
  imageAlt?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentModulesImageTextItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentModulesImageTextItemFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionsCz10Accordion = {
  __typename?: 'ComponentSectionsCz10Accordion';
  accordionItem?: Maybe<Array<Maybe<ComponentModulesAccordionItem>>>;
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};


export type ComponentSectionsCz10AccordionAccordionItemArgs = {
  filters?: InputMaybe<ComponentModulesAccordionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsCz11Cta = {
  __typename?: 'ComponentSectionsCz11Cta';
  ctaItem?: Maybe<Array<Maybe<ComponentModulesCtaItem>>>;
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
};


export type ComponentSectionsCz11CtaCtaItemArgs = {
  filters?: InputMaybe<ComponentModulesCtaItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsCz12TextBlock = {
  __typename?: 'ComponentSectionsCz12TextBlock';
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentSectionsCz13ImageWithText = {
  __typename?: 'ComponentSectionsCz13ImageWithText';
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  imageTextItem?: Maybe<Array<Maybe<ComponentModulesImageTextItem>>>;
};


export type ComponentSectionsCz13ImageWithTextImageTextItemArgs = {
  filters?: InputMaybe<ComponentModulesImageTextItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsCz14ImageGallery = {
  __typename?: 'ComponentSectionsCz14ImageGallery';
  customerGroups?: Maybe<Scalars['JSON']>;
  galleryItem?: Maybe<Array<Maybe<ComponentModulesGalleryItem>>>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};


export type ComponentSectionsCz14ImageGalleryGalleryItemArgs = {
  filters?: InputMaybe<ComponentModulesGalleryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsCz15Article = {
  __typename?: 'ComponentSectionsCz15Article';
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  imageMobile?: Maybe<UploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentSectionsCz16Features = {
  __typename?: 'ComponentSectionsCz16Features';
  FeatItem?: Maybe<Array<Maybe<ComponentModulesFeatItem>>>;
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};


export type ComponentSectionsCz16FeaturesFeatItemArgs = {
  filters?: InputMaybe<ComponentModulesFeatItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsCzAboutUs = {
  __typename?: 'ComponentSectionsCzAboutUs';
  AboutItem?: Maybe<Array<Maybe<ComponentModulesAboutItem>>>;
  customerGroups?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentSectionsCzAboutUsAboutItemArgs = {
  filters?: InputMaybe<ComponentModulesAboutItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionsS55Form = {
  __typename?: 'ComponentSectionsS55Form';
  customerGroups?: Maybe<Scalars['JSON']>;
  emailRecipients?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<ComponentModulesFormItem>>>;
  formName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  submitText?: Maybe<Scalars['String']>;
};


export type ComponentSectionsS55FormFieldsArgs = {
  filters?: InputMaybe<ComponentModulesFormItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  nei?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export enum Enum_Componentmodulesformitem_Inputtype {
  Checkbox = 'checkbox',
  Date = 'date',
  Email = 'email',
  MultilineText = 'multiline_text',
  Number = 'number',
  Salutation = 'salutation',
  Tel = 'tel',
  Text = 'text'
}

export enum Enum_Componentmodulesimagetextitem_Alignment {
  Left = 'Left',
  Right = 'Right'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nei?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = CategoryContent | ComponentBasicBlockS1Banner | ComponentBasicBlockS3SingleProduct | ComponentBasicBlockS4ProductList | ComponentModulesAboutItem | ComponentModulesAccordionItem | ComponentModulesCtaItem | ComponentModulesFeatItem | ComponentModulesFormItem | ComponentModulesGalleryItem | ComponentModulesImageTextItem | ComponentSectionsCz10Accordion | ComponentSectionsCz11Cta | ComponentSectionsCz12TextBlock | ComponentSectionsCz13ImageWithText | ComponentSectionsCz14ImageGallery | ComponentSectionsCz15Article | ComponentSectionsCz16Features | ComponentSectionsCzAboutUs | ComponentSectionsS55Form | I18NLocale | LandingSite | Message | Page | ProductContent | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  nei?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nei?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nei?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type LandingSite = {
  __typename?: 'LandingSite';
  body?: Maybe<Array<Maybe<LandingSiteBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<LandingSiteRelationResponseCollection>;
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type LandingSiteLocalizationsArgs = {
  filters?: InputMaybe<LandingSiteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingSiteBodyDynamicZone = ComponentBasicBlockS1Banner | ComponentBasicBlockS3SingleProduct | ComponentBasicBlockS4ProductList | ComponentSectionsCz10Accordion | ComponentSectionsCz11Cta | ComponentSectionsCz12TextBlock | ComponentSectionsCz13ImageWithText | ComponentSectionsCz14ImageGallery | ComponentSectionsCz15Article | ComponentSectionsCz16Features | ComponentSectionsCzAboutUs | ComponentSectionsS55Form | Error;

export type LandingSiteEntity = {
  __typename?: 'LandingSiteEntity';
  attributes?: Maybe<LandingSite>;
  id?: Maybe<Scalars['ID']>;
};

export type LandingSiteEntityResponse = {
  __typename?: 'LandingSiteEntityResponse';
  data?: Maybe<LandingSiteEntity>;
};

export type LandingSiteEntityResponseCollection = {
  __typename?: 'LandingSiteEntityResponseCollection';
  data: Array<LandingSiteEntity>;
  meta: ResponseCollectionMeta;
};

export type LandingSiteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LandingSiteFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LandingSiteFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LandingSiteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LandingSiteFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LandingSiteInput = {
  body?: InputMaybe<Array<Scalars['LandingSiteBodyDynamicZoneInput']>>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingSiteRelationResponseCollection = {
  __typename?: 'LandingSiteRelationResponseCollection';
  data: Array<LandingSiteEntity>;
};

export type Message = {
  __typename?: 'Message';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<MessageRelationResponseCollection>;
  message?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MessageLocalizationsArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MessageEntity = {
  __typename?: 'MessageEntity';
  attributes?: Maybe<Message>;
  id?: Maybe<Scalars['ID']>;
};

export type MessageEntityResponse = {
  __typename?: 'MessageEntityResponse';
  data?: Maybe<MessageEntity>;
};

export type MessageEntityResponseCollection = {
  __typename?: 'MessageEntityResponseCollection';
  data: Array<MessageEntity>;
  meta: ResponseCollectionMeta;
};

export type MessageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MessageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<MessageFiltersInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MessageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MessageFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MessageInput = {
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
};

export type MessageRelationResponseCollection = {
  __typename?: 'MessageRelationResponseCollection';
  data: Array<MessageEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createCategoryContent?: Maybe<CategoryContentEntityResponse>;
  createCategoryContentLocalization?: Maybe<CategoryContentEntityResponse>;
  createLandingSite?: Maybe<LandingSiteEntityResponse>;
  createLandingSiteLocalization?: Maybe<LandingSiteEntityResponse>;
  createMessage?: Maybe<MessageEntityResponse>;
  createMessageLocalization?: Maybe<MessageEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createPageLocalization?: Maybe<PageEntityResponse>;
  createProductContent?: Maybe<ProductContentEntityResponse>;
  createProductContentLocalization?: Maybe<ProductContentEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteCategoryContent?: Maybe<CategoryContentEntityResponse>;
  deleteLandingSite?: Maybe<LandingSiteEntityResponse>;
  deleteMessage?: Maybe<MessageEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deleteProductContent?: Maybe<ProductContentEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateCategoryContent?: Maybe<CategoryContentEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateLandingSite?: Maybe<LandingSiteEntityResponse>;
  updateMessage?: Maybe<MessageEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updateProductContent?: Maybe<ProductContentEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateCategoryContentArgs = {
  data: CategoryContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCategoryContentLocalizationArgs = {
  data?: InputMaybe<CategoryContentInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateLandingSiteArgs = {
  data: LandingSiteInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateLandingSiteLocalizationArgs = {
  data?: InputMaybe<LandingSiteInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateMessageArgs = {
  data: MessageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateMessageLocalizationArgs = {
  data?: InputMaybe<MessageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageArgs = {
  data: PageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageLocalizationArgs = {
  data?: InputMaybe<PageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateProductContentArgs = {
  data: ProductContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateProductContentLocalizationArgs = {
  data?: InputMaybe<ProductContentInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteCategoryContentArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteLandingSiteArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteProductContentArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateCategoryContentArgs = {
  data: CategoryContentInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateLandingSiteArgs = {
  data: LandingSiteInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateMessageArgs = {
  data: MessageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateProductContentArgs = {
  data: ProductContentInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  externalPath?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  master?: Maybe<Scalars['Int']>;
  menuAttached: Scalars['Boolean'];
  order: Scalars['Int'];
  parent?: Maybe<NavigationItem>;
  path?: Maybe<Scalars['String']>;
  related?: Maybe<NavigationItemRelatedData>;
  title: Scalars['String'];
  type: Scalars['String'];
  uiRouterKey: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type NavigationItemRelated = LandingSite;

export type NavigationItemRelatedData = {
  __typename?: 'NavigationItemRelatedData';
  attributes?: Maybe<NavigationItemRelated>;
  id: Scalars['Int'];
};

export enum NavigationRenderType {
  Flat = 'FLAT',
  Rfr = 'RFR',
  Tree = 'TREE'
}

export type Page = {
  __typename?: 'Page';
  body?: Maybe<Array<Maybe<PageBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PageLocalizationsArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageBodyDynamicZone = ComponentBasicBlockS1Banner | ComponentBasicBlockS3SingleProduct | ComponentBasicBlockS4ProductList | ComponentSectionsCz10Accordion | ComponentSectionsCz11Cta | ComponentSectionsCz12TextBlock | ComponentSectionsCz13ImageWithText | ComponentSectionsCz14ImageGallery | ComponentSectionsCz15Article | ComponentSectionsCz16Features | ComponentSectionsCzAboutUs | ComponentSectionsS55Form | Error;

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  body?: InputMaybe<Array<Scalars['PageBodyDynamicZoneInput']>>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<PageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type ProductContent = {
  __typename?: 'ProductContent';
  banner?: Maybe<ComponentBasicBlockS1Banner>;
  createdAt?: Maybe<Scalars['DateTime']>;
  info?: Maybe<ComponentBasicBlockS1Banner>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<ProductContentRelationResponseCollection>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ProductContentLocalizationsArgs = {
  filters?: InputMaybe<ProductContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductContentEntity = {
  __typename?: 'ProductContentEntity';
  attributes?: Maybe<ProductContent>;
  id?: Maybe<Scalars['ID']>;
};

export type ProductContentEntityResponse = {
  __typename?: 'ProductContentEntityResponse';
  data?: Maybe<ProductContentEntity>;
};

export type ProductContentEntityResponseCollection = {
  __typename?: 'ProductContentEntityResponseCollection';
  data: Array<ProductContentEntity>;
  meta: ResponseCollectionMeta;
};

export type ProductContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductContentFiltersInput>>>;
  banner?: InputMaybe<ComponentBasicBlockS1BannerFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<ComponentBasicBlockS1BannerFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductContentFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductContentFiltersInput>>>;
  productId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductContentInput = {
  banner?: InputMaybe<ComponentBasicBlockS1BannerInput>;
  info?: InputMaybe<ComponentBasicBlockS1BannerInput>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductContentRelationResponseCollection = {
  __typename?: 'ProductContentRelationResponseCollection';
  data: Array<ProductContentEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  categoryContent?: Maybe<CategoryContentEntityResponse>;
  categoryContents?: Maybe<CategoryContentEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  landingSite?: Maybe<LandingSiteEntityResponse>;
  landingSites?: Maybe<LandingSiteEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  message?: Maybe<MessageEntityResponse>;
  messages?: Maybe<MessageEntityResponseCollection>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  productContent?: Maybe<ProductContentEntityResponse>;
  productContents?: Maybe<ProductContentEntityResponseCollection>;
  renderNavigation: Array<Maybe<NavigationItem>>;
  renderNavigationChild: Array<Maybe<NavigationItem>>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryCategoryContentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryCategoryContentsArgs = {
  filters?: InputMaybe<CategoryContentFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryLandingSiteArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryLandingSitesArgs = {
  filters?: InputMaybe<LandingSiteFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMessageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryMessagesArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProductContentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryProductContentsArgs = {
  filters?: InputMaybe<ProductContentFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRenderNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  navigationIdOrSlug: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NavigationRenderType>;
};


export type QueryRenderNavigationChildArgs = {
  childUiKey: Scalars['String'];
  id: Scalars['String'];
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<NavigationRenderType>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nei?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type GetAllPagesQueryVariables = Exact<{
  menuPath: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
  menu: Scalars['String'];
}>;


export type GetAllPagesQuery = { __typename?: 'Query', allPagesMainMenu: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, updatedAt?: string | null, externalPath?: string | null, type: string, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> };

export type RenderNaviagtionQueryVariables = Exact<{
  name: Scalars['String'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type RenderNaviagtionQuery = { __typename?: 'Query', renderMenu: Array<{ __typename?: 'NavigationItem', path?: string | null, title: string, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null } | null> | null } | null> };

export type GetEveryPageQueryVariables = Exact<{
  menuPath: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
}>;


export type GetEveryPageQuery = { __typename?: 'Query', allPagesMainMenu: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, updatedAt?: string | null, externalPath?: string | null, type: string, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> };

export type GetLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalesQuery = { __typename?: 'Query', i18NLocales?: { __typename?: 'I18NLocaleEntityResponseCollection', data: Array<{ __typename?: 'I18NLocaleEntity', attributes?: { __typename?: 'I18NLocale', code?: string | null } | null }> } | null };

export type PageFragment = { __typename?: 'Page', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null };

export type LandingSiteFragment = { __typename?: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null };

export type AllPagesNavigationItemFragment = { __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null };

export type AllPagesNavigationItemPageRelationFragment = { __typename?: 'NavigationItem', related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null };

export type AllPagesPageDataFragment = { __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null };

export type AllPagesNavigationFragment = { __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null };

export type AllPagesNavigationWrapperFragment = { __typename?: 'NavigationItem', id: number, title: string, path?: string | null, updatedAt?: string | null, externalPath?: string | null, type: string, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null };

export type NavigationItemFragment = { __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null };

export type NavigationItemPageRelationFragment = { __typename?: 'NavigationItem', related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null };

export type NavigationFragment = { __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null };

export type NavigationWrapperFragment = { __typename?: 'NavigationItem', id: number, title: string, path?: string | null, updatedAt?: string | null, type: string, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, items?: Array<{ __typename?: 'NavigationItem', title: string, path?: string | null, externalPath?: string | null, type: string, updatedAt?: string | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null, related?: { __typename?: 'NavigationItemRelatedData', attributes?: { __typename: 'LandingSite', body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null> | null, parent?: { __typename?: 'NavigationItem', path?: string | null } | null } | null> | null };

export type CreateMessageMutationVariables = Exact<{
  input: MessageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage?: { __typename?: 'MessageEntityResponse', data?: { __typename?: 'MessageEntity', id?: string | null } | null } | null };

export type PageCollectionsFragment = { __typename?: 'NavigationItem', title: string, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'LandingSite' } | null } | null };

export type GetPageByPathQueryVariables = Exact<{
  path: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
  menu: Scalars['String'];
}>;


export type GetPageByPathQuery = { __typename?: 'Query', pageInMainMenu: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string | null, related?: { __typename?: 'NavigationItemRelatedData', id: number, attributes?: { __typename: 'LandingSite' } | null } | null } | null> };

export type GetPageByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPageByIdQuery = { __typename?: 'Query', page?: { __typename: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename: 'Page', name: string, locale?: string | null, body?: Array<{ __typename?: 'ComponentBasicBlockS1Banner' } | { __typename?: 'ComponentBasicBlockS3SingleProduct' } | { __typename?: 'ComponentBasicBlockS4ProductList' } | { __typename?: 'ComponentSectionsCz10Accordion' } | { __typename?: 'ComponentSectionsCz11Cta' } | { __typename?: 'ComponentSectionsCz12TextBlock' } | { __typename?: 'ComponentSectionsCz13ImageWithText' } | { __typename?: 'ComponentSectionsCz14ImageGallery' } | { __typename?: 'ComponentSectionsCz15Article' } | { __typename?: 'ComponentSectionsCz16Features' } | { __typename?: 'ComponentSectionsCzAboutUs' } | { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null };

export type S55FormFragment = { __typename?: 'ComponentSectionsS55Form', id: string, formName?: string | null, submitText?: string | null, emailRecipients?: string | null, customerGroups?: any | null, fields?: Array<{ __typename?: 'ComponentModulesFormItem', id: string, inputType?: Enum_Componentmodulesformitem_Inputtype | null, displayName: string, placeholder?: string | null, required?: boolean | null } | null> | null };

export type S1BannerFragment = { __typename?: 'ComponentBasicBlockS1Banner', title?: string | null, description?: string | null, customerGroups?: any | null, buttonText?: string | null, buttonUrl?: string | null, targetBlank?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

export type S4ProductListFragment = { __typename?: 'ComponentBasicBlockS4ProductList', id: string, category?: string | null, customerGroups?: any | null, Products?: Array<{ __typename?: 'ComponentBasicBlockS3SingleProduct', product?: string | null } | null> | null };

export type S3SingleProductFragment = { __typename?: 'ComponentBasicBlockS3SingleProduct', id: string, product?: string | null, customerGroups?: any | null };

export type Cz12TextBlockFragment = { __typename?: 'ComponentSectionsCz12TextBlock', id: string, title?: string | null, subtitle?: string | null, text?: string | null, customerGroups?: any | null };

export type Cz10AccordionFragment = { __typename?: 'ComponentSectionsCz10Accordion', id: string, title?: string | null, customerGroups?: any | null, accordionItem?: Array<{ __typename?: 'ComponentModulesAccordionItem', title: string, text?: string | null } | null> | null };

export type Cz15ArticleFragment = { __typename?: 'ComponentSectionsCz15Article', id: string, title?: string | null, subtitle?: string | null, text?: string | null, customerGroups?: any | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null, imageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type Cz11CtaFragment = { __typename?: 'ComponentSectionsCz11Cta', id: string, customerGroups?: any | null, ctaItem?: Array<{ __typename?: 'ComponentModulesCtaItem', id: string, title?: string | null, subtitle?: string | null, text?: string | null, buttonText?: string | null, buttonUrl?: string | null, iconAlt?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null };

export type Cz13ImageWithTextFragment = { __typename?: 'ComponentSectionsCz13ImageWithText', id: string, customerGroups?: any | null, imageTextItem?: Array<{ __typename?: 'ComponentModulesImageTextItem', alignment?: Enum_Componentmodulesimagetextitem_Alignment | null, title?: string | null, subtitle?: string | null, text?: string | null, imageAlt?: string | null, buttonText?: string | null, buttonUrl?: string | null, buttonTargetBlank?: boolean | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null }, imageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null> | null };

export type CzAboutUsFragment = { __typename?: 'ComponentSectionsCzAboutUs', title?: string | null, subtitle?: string | null, text?: string | null, customerGroups?: any | null, AboutItem?: Array<{ __typename?: 'ComponentModulesAboutItem', title?: string | null, subtitle?: string | null, imageAlt?: string | null, imageTitle?: string | null, linkUrl?: string | null, targetBlank?: boolean | null, image?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null }> } | null, imageMobile?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null }> } | null } | null> | null };

export type Cz16FeaturesFragment = { __typename?: 'ComponentSectionsCz16Features', id: string, title?: string | null, customerGroups?: any | null, FeatItem?: Array<{ __typename?: 'ComponentModulesFeatItem', id: string, imageAlt?: string | null, imageTitle?: string | null, title?: string | null, text?: string | null, linkUrl?: string | null, targetBlank?: boolean | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null };

export type Cz14ImageGalleryFragment = { __typename?: 'ComponentSectionsCz14ImageGallery', title?: string | null, customerGroups?: any | null, galleryItem?: Array<{ __typename?: 'ComponentModulesGalleryItem', id: string, text?: string | null, imageAlt?: string | null, imageTitle?: string | null, linkUrl?: string | null, linkTargetBlank?: boolean | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null }, imageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null> | null };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes = {
  CategoryContentBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
  GenericMorph: ( Omit<CategoryContent, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['CategoryContentBodyDynamicZone']>>> } ) | ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentModulesAboutItem ) | ( ComponentModulesAccordionItem ) | ( ComponentModulesCtaItem ) | ( ComponentModulesFeatItem ) | ( ComponentModulesFormItem ) | ( ComponentModulesGalleryItem ) | ( ComponentModulesImageTextItem ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( I18NLocale ) | ( Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['LandingSiteBodyDynamicZone']>>> } ) | ( Message ) | ( Omit<Page, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['PageBodyDynamicZone']>>> } ) | ( ProductContent ) | ( Omit<UploadFile, 'related'> & { related?: Maybe<Array<Maybe<ResolversTypes['GenericMorph']>>> } ) | ( UploadFolder ) | ( UsersPermissionsPermission ) | ( UsersPermissionsRole ) | ( UsersPermissionsUser );
  LandingSiteBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
  NavigationItemRelated: ( Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['LandingSiteBodyDynamicZone']>>> } );
  PageBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
};

/** Mapping of union parent types */
export type ResolversUnionParentTypes = {
  CategoryContentBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
  GenericMorph: ( Omit<CategoryContent, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['CategoryContentBodyDynamicZone']>>> } ) | ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentModulesAboutItem ) | ( ComponentModulesAccordionItem ) | ( ComponentModulesCtaItem ) | ( ComponentModulesFeatItem ) | ( ComponentModulesFormItem ) | ( ComponentModulesGalleryItem ) | ( ComponentModulesImageTextItem ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( I18NLocale ) | ( Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['LandingSiteBodyDynamicZone']>>> } ) | ( Message ) | ( Omit<Page, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['PageBodyDynamicZone']>>> } ) | ( ProductContent ) | ( Omit<UploadFile, 'related'> & { related?: Maybe<Array<Maybe<ResolversParentTypes['GenericMorph']>>> } ) | ( UploadFolder ) | ( UsersPermissionsPermission ) | ( UsersPermissionsRole ) | ( UsersPermissionsUser );
  LandingSiteBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
  NavigationItemRelated: ( Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['LandingSiteBodyDynamicZone']>>> } );
  PageBodyDynamicZone: ( ComponentBasicBlockS1Banner ) | ( ComponentBasicBlockS3SingleProduct ) | ( ComponentBasicBlockS4ProductList ) | ( ComponentSectionsCz10Accordion ) | ( ComponentSectionsCz11Cta ) | ( ComponentSectionsCz12TextBlock ) | ( ComponentSectionsCz13ImageWithText ) | ( ComponentSectionsCz14ImageGallery ) | ( ComponentSectionsCz15Article ) | ( ComponentSectionsCz16Features ) | ( ComponentSectionsCzAboutUs ) | ( ComponentSectionsS55Form ) | ( Error );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BooleanFilterInput: BooleanFilterInput;
  CategoryContent: ResolverTypeWrapper<Omit<CategoryContent, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['CategoryContentBodyDynamicZone']>>> }>;
  CategoryContentBodyDynamicZone: ResolverTypeWrapper<ResolversUnionTypes['CategoryContentBodyDynamicZone']>;
  CategoryContentBodyDynamicZoneInput: ResolverTypeWrapper<Scalars['CategoryContentBodyDynamicZoneInput']>;
  CategoryContentEntity: ResolverTypeWrapper<CategoryContentEntity>;
  CategoryContentEntityResponse: ResolverTypeWrapper<CategoryContentEntityResponse>;
  CategoryContentEntityResponseCollection: ResolverTypeWrapper<CategoryContentEntityResponseCollection>;
  CategoryContentFiltersInput: CategoryContentFiltersInput;
  CategoryContentInput: CategoryContentInput;
  CategoryContentRelationResponseCollection: ResolverTypeWrapper<CategoryContentRelationResponseCollection>;
  ComponentBasicBlockS1Banner: ResolverTypeWrapper<ComponentBasicBlockS1Banner>;
  ComponentBasicBlockS1BannerFiltersInput: ComponentBasicBlockS1BannerFiltersInput;
  ComponentBasicBlockS1BannerInput: ComponentBasicBlockS1BannerInput;
  ComponentBasicBlockS3SingleProduct: ResolverTypeWrapper<ComponentBasicBlockS3SingleProduct>;
  ComponentBasicBlockS3SingleProductFiltersInput: ComponentBasicBlockS3SingleProductFiltersInput;
  ComponentBasicBlockS4ProductList: ResolverTypeWrapper<ComponentBasicBlockS4ProductList>;
  ComponentModulesAboutItem: ResolverTypeWrapper<ComponentModulesAboutItem>;
  ComponentModulesAboutItemFiltersInput: ComponentModulesAboutItemFiltersInput;
  ComponentModulesAccordionItem: ResolverTypeWrapper<ComponentModulesAccordionItem>;
  ComponentModulesAccordionItemFiltersInput: ComponentModulesAccordionItemFiltersInput;
  ComponentModulesCtaItem: ResolverTypeWrapper<ComponentModulesCtaItem>;
  ComponentModulesCtaItemFiltersInput: ComponentModulesCtaItemFiltersInput;
  ComponentModulesFeatItem: ResolverTypeWrapper<ComponentModulesFeatItem>;
  ComponentModulesFeatItemFiltersInput: ComponentModulesFeatItemFiltersInput;
  ComponentModulesFormItem: ResolverTypeWrapper<ComponentModulesFormItem>;
  ComponentModulesFormItemFiltersInput: ComponentModulesFormItemFiltersInput;
  ComponentModulesGalleryItem: ResolverTypeWrapper<ComponentModulesGalleryItem>;
  ComponentModulesGalleryItemFiltersInput: ComponentModulesGalleryItemFiltersInput;
  ComponentModulesImageTextItem: ResolverTypeWrapper<ComponentModulesImageTextItem>;
  ComponentModulesImageTextItemFiltersInput: ComponentModulesImageTextItemFiltersInput;
  ComponentSectionsCz10Accordion: ResolverTypeWrapper<ComponentSectionsCz10Accordion>;
  ComponentSectionsCz11Cta: ResolverTypeWrapper<ComponentSectionsCz11Cta>;
  ComponentSectionsCz12TextBlock: ResolverTypeWrapper<ComponentSectionsCz12TextBlock>;
  ComponentSectionsCz13ImageWithText: ResolverTypeWrapper<ComponentSectionsCz13ImageWithText>;
  ComponentSectionsCz14ImageGallery: ResolverTypeWrapper<ComponentSectionsCz14ImageGallery>;
  ComponentSectionsCz15Article: ResolverTypeWrapper<ComponentSectionsCz15Article>;
  ComponentSectionsCz16Features: ResolverTypeWrapper<ComponentSectionsCz16Features>;
  ComponentSectionsCzAboutUs: ResolverTypeWrapper<ComponentSectionsCzAboutUs>;
  ComponentSectionsS55Form: ResolverTypeWrapper<ComponentSectionsS55Form>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  DateTimeFilterInput: DateTimeFilterInput;
  ENUM_COMPONENTMODULESFORMITEM_INPUTTYPE: Enum_Componentmodulesformitem_Inputtype;
  ENUM_COMPONENTMODULESIMAGETEXTITEM_ALIGNMENT: Enum_Componentmodulesimagetextitem_Alignment;
  Error: ResolverTypeWrapper<Error>;
  FileInfoInput: FileInfoInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FloatFilterInput: FloatFilterInput;
  GenericMorph: ResolverTypeWrapper<ResolversUnionTypes['GenericMorph']>;
  I18NLocale: ResolverTypeWrapper<I18NLocale>;
  I18NLocaleCode: ResolverTypeWrapper<Scalars['I18NLocaleCode']>;
  I18NLocaleEntity: ResolverTypeWrapper<I18NLocaleEntity>;
  I18NLocaleEntityResponse: ResolverTypeWrapper<I18NLocaleEntityResponse>;
  I18NLocaleEntityResponseCollection: ResolverTypeWrapper<I18NLocaleEntityResponseCollection>;
  I18NLocaleFiltersInput: I18NLocaleFiltersInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IDFilterInput: IdFilterInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  IntFilterInput: IntFilterInput;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JSONFilterInput: JsonFilterInput;
  LandingSite: ResolverTypeWrapper<Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['LandingSiteBodyDynamicZone']>>> }>;
  LandingSiteBodyDynamicZone: ResolverTypeWrapper<ResolversUnionTypes['LandingSiteBodyDynamicZone']>;
  LandingSiteBodyDynamicZoneInput: ResolverTypeWrapper<Scalars['LandingSiteBodyDynamicZoneInput']>;
  LandingSiteEntity: ResolverTypeWrapper<LandingSiteEntity>;
  LandingSiteEntityResponse: ResolverTypeWrapper<LandingSiteEntityResponse>;
  LandingSiteEntityResponseCollection: ResolverTypeWrapper<LandingSiteEntityResponseCollection>;
  LandingSiteFiltersInput: LandingSiteFiltersInput;
  LandingSiteInput: LandingSiteInput;
  LandingSiteRelationResponseCollection: ResolverTypeWrapper<LandingSiteRelationResponseCollection>;
  Message: ResolverTypeWrapper<Message>;
  MessageEntity: ResolverTypeWrapper<MessageEntity>;
  MessageEntityResponse: ResolverTypeWrapper<MessageEntityResponse>;
  MessageEntityResponseCollection: ResolverTypeWrapper<MessageEntityResponseCollection>;
  MessageFiltersInput: MessageFiltersInput;
  MessageInput: MessageInput;
  MessageRelationResponseCollection: ResolverTypeWrapper<MessageRelationResponseCollection>;
  Mutation: ResolverTypeWrapper<{}>;
  NavigationItem: ResolverTypeWrapper<NavigationItem>;
  NavigationItemRelated: ResolverTypeWrapper<ResolversUnionTypes['NavigationItemRelated']>;
  NavigationItemRelatedData: ResolverTypeWrapper<Omit<NavigationItemRelatedData, 'attributes'> & { attributes?: Maybe<ResolversTypes['NavigationItemRelated']> }>;
  NavigationRenderType: NavigationRenderType;
  Page: ResolverTypeWrapper<Omit<Page, 'body'> & { body?: Maybe<Array<Maybe<ResolversTypes['PageBodyDynamicZone']>>> }>;
  PageBodyDynamicZone: ResolverTypeWrapper<ResolversUnionTypes['PageBodyDynamicZone']>;
  PageBodyDynamicZoneInput: ResolverTypeWrapper<Scalars['PageBodyDynamicZoneInput']>;
  PageEntity: ResolverTypeWrapper<PageEntity>;
  PageEntityResponse: ResolverTypeWrapper<PageEntityResponse>;
  PageEntityResponseCollection: ResolverTypeWrapper<PageEntityResponseCollection>;
  PageFiltersInput: PageFiltersInput;
  PageInput: PageInput;
  PageRelationResponseCollection: ResolverTypeWrapper<PageRelationResponseCollection>;
  Pagination: ResolverTypeWrapper<Pagination>;
  PaginationArg: PaginationArg;
  ProductContent: ResolverTypeWrapper<ProductContent>;
  ProductContentEntity: ResolverTypeWrapper<ProductContentEntity>;
  ProductContentEntityResponse: ResolverTypeWrapper<ProductContentEntityResponse>;
  ProductContentEntityResponseCollection: ResolverTypeWrapper<ProductContentEntityResponseCollection>;
  ProductContentFiltersInput: ProductContentFiltersInput;
  ProductContentInput: ProductContentInput;
  ProductContentRelationResponseCollection: ResolverTypeWrapper<ProductContentRelationResponseCollection>;
  PublicationState: PublicationState;
  Query: ResolverTypeWrapper<{}>;
  ResponseCollectionMeta: ResolverTypeWrapper<ResponseCollectionMeta>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StringFilterInput: StringFilterInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  UploadFile: ResolverTypeWrapper<Omit<UploadFile, 'related'> & { related?: Maybe<Array<Maybe<ResolversTypes['GenericMorph']>>> }>;
  UploadFileEntity: ResolverTypeWrapper<UploadFileEntity>;
  UploadFileEntityResponse: ResolverTypeWrapper<UploadFileEntityResponse>;
  UploadFileEntityResponseCollection: ResolverTypeWrapper<UploadFileEntityResponseCollection>;
  UploadFileFiltersInput: UploadFileFiltersInput;
  UploadFileInput: UploadFileInput;
  UploadFileRelationResponseCollection: ResolverTypeWrapper<UploadFileRelationResponseCollection>;
  UploadFolder: ResolverTypeWrapper<UploadFolder>;
  UploadFolderEntity: ResolverTypeWrapper<UploadFolderEntity>;
  UploadFolderEntityResponse: ResolverTypeWrapper<UploadFolderEntityResponse>;
  UploadFolderEntityResponseCollection: ResolverTypeWrapper<UploadFolderEntityResponseCollection>;
  UploadFolderFiltersInput: UploadFolderFiltersInput;
  UploadFolderInput: UploadFolderInput;
  UploadFolderRelationResponseCollection: ResolverTypeWrapper<UploadFolderRelationResponseCollection>;
  UsersPermissionsCreateRolePayload: ResolverTypeWrapper<UsersPermissionsCreateRolePayload>;
  UsersPermissionsDeleteRolePayload: ResolverTypeWrapper<UsersPermissionsDeleteRolePayload>;
  UsersPermissionsLoginInput: UsersPermissionsLoginInput;
  UsersPermissionsLoginPayload: ResolverTypeWrapper<UsersPermissionsLoginPayload>;
  UsersPermissionsMe: ResolverTypeWrapper<UsersPermissionsMe>;
  UsersPermissionsMeRole: ResolverTypeWrapper<UsersPermissionsMeRole>;
  UsersPermissionsPasswordPayload: ResolverTypeWrapper<UsersPermissionsPasswordPayload>;
  UsersPermissionsPermission: ResolverTypeWrapper<UsersPermissionsPermission>;
  UsersPermissionsPermissionEntity: ResolverTypeWrapper<UsersPermissionsPermissionEntity>;
  UsersPermissionsPermissionFiltersInput: UsersPermissionsPermissionFiltersInput;
  UsersPermissionsPermissionRelationResponseCollection: ResolverTypeWrapper<UsersPermissionsPermissionRelationResponseCollection>;
  UsersPermissionsRegisterInput: UsersPermissionsRegisterInput;
  UsersPermissionsRole: ResolverTypeWrapper<UsersPermissionsRole>;
  UsersPermissionsRoleEntity: ResolverTypeWrapper<UsersPermissionsRoleEntity>;
  UsersPermissionsRoleEntityResponse: ResolverTypeWrapper<UsersPermissionsRoleEntityResponse>;
  UsersPermissionsRoleEntityResponseCollection: ResolverTypeWrapper<UsersPermissionsRoleEntityResponseCollection>;
  UsersPermissionsRoleFiltersInput: UsersPermissionsRoleFiltersInput;
  UsersPermissionsRoleInput: UsersPermissionsRoleInput;
  UsersPermissionsUpdateRolePayload: ResolverTypeWrapper<UsersPermissionsUpdateRolePayload>;
  UsersPermissionsUser: ResolverTypeWrapper<UsersPermissionsUser>;
  UsersPermissionsUserEntity: ResolverTypeWrapper<UsersPermissionsUserEntity>;
  UsersPermissionsUserEntityResponse: ResolverTypeWrapper<UsersPermissionsUserEntityResponse>;
  UsersPermissionsUserEntityResponseCollection: ResolverTypeWrapper<UsersPermissionsUserEntityResponseCollection>;
  UsersPermissionsUserFiltersInput: UsersPermissionsUserFiltersInput;
  UsersPermissionsUserInput: UsersPermissionsUserInput;
  UsersPermissionsUserRelationResponseCollection: ResolverTypeWrapper<UsersPermissionsUserRelationResponseCollection>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean'];
  BooleanFilterInput: BooleanFilterInput;
  CategoryContent: Omit<CategoryContent, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['CategoryContentBodyDynamicZone']>>> };
  CategoryContentBodyDynamicZone: ResolversUnionParentTypes['CategoryContentBodyDynamicZone'];
  CategoryContentBodyDynamicZoneInput: Scalars['CategoryContentBodyDynamicZoneInput'];
  CategoryContentEntity: CategoryContentEntity;
  CategoryContentEntityResponse: CategoryContentEntityResponse;
  CategoryContentEntityResponseCollection: CategoryContentEntityResponseCollection;
  CategoryContentFiltersInput: CategoryContentFiltersInput;
  CategoryContentInput: CategoryContentInput;
  CategoryContentRelationResponseCollection: CategoryContentRelationResponseCollection;
  ComponentBasicBlockS1Banner: ComponentBasicBlockS1Banner;
  ComponentBasicBlockS1BannerFiltersInput: ComponentBasicBlockS1BannerFiltersInput;
  ComponentBasicBlockS1BannerInput: ComponentBasicBlockS1BannerInput;
  ComponentBasicBlockS3SingleProduct: ComponentBasicBlockS3SingleProduct;
  ComponentBasicBlockS3SingleProductFiltersInput: ComponentBasicBlockS3SingleProductFiltersInput;
  ComponentBasicBlockS4ProductList: ComponentBasicBlockS4ProductList;
  ComponentModulesAboutItem: ComponentModulesAboutItem;
  ComponentModulesAboutItemFiltersInput: ComponentModulesAboutItemFiltersInput;
  ComponentModulesAccordionItem: ComponentModulesAccordionItem;
  ComponentModulesAccordionItemFiltersInput: ComponentModulesAccordionItemFiltersInput;
  ComponentModulesCtaItem: ComponentModulesCtaItem;
  ComponentModulesCtaItemFiltersInput: ComponentModulesCtaItemFiltersInput;
  ComponentModulesFeatItem: ComponentModulesFeatItem;
  ComponentModulesFeatItemFiltersInput: ComponentModulesFeatItemFiltersInput;
  ComponentModulesFormItem: ComponentModulesFormItem;
  ComponentModulesFormItemFiltersInput: ComponentModulesFormItemFiltersInput;
  ComponentModulesGalleryItem: ComponentModulesGalleryItem;
  ComponentModulesGalleryItemFiltersInput: ComponentModulesGalleryItemFiltersInput;
  ComponentModulesImageTextItem: ComponentModulesImageTextItem;
  ComponentModulesImageTextItemFiltersInput: ComponentModulesImageTextItemFiltersInput;
  ComponentSectionsCz10Accordion: ComponentSectionsCz10Accordion;
  ComponentSectionsCz11Cta: ComponentSectionsCz11Cta;
  ComponentSectionsCz12TextBlock: ComponentSectionsCz12TextBlock;
  ComponentSectionsCz13ImageWithText: ComponentSectionsCz13ImageWithText;
  ComponentSectionsCz14ImageGallery: ComponentSectionsCz14ImageGallery;
  ComponentSectionsCz15Article: ComponentSectionsCz15Article;
  ComponentSectionsCz16Features: ComponentSectionsCz16Features;
  ComponentSectionsCzAboutUs: ComponentSectionsCzAboutUs;
  ComponentSectionsS55Form: ComponentSectionsS55Form;
  DateTime: Scalars['DateTime'];
  DateTimeFilterInput: DateTimeFilterInput;
  Error: Error;
  FileInfoInput: FileInfoInput;
  Float: Scalars['Float'];
  FloatFilterInput: FloatFilterInput;
  GenericMorph: ResolversUnionParentTypes['GenericMorph'];
  I18NLocale: I18NLocale;
  I18NLocaleCode: Scalars['I18NLocaleCode'];
  I18NLocaleEntity: I18NLocaleEntity;
  I18NLocaleEntityResponse: I18NLocaleEntityResponse;
  I18NLocaleEntityResponseCollection: I18NLocaleEntityResponseCollection;
  I18NLocaleFiltersInput: I18NLocaleFiltersInput;
  ID: Scalars['ID'];
  IDFilterInput: IdFilterInput;
  Int: Scalars['Int'];
  IntFilterInput: IntFilterInput;
  JSON: Scalars['JSON'];
  JSONFilterInput: JsonFilterInput;
  LandingSite: Omit<LandingSite, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['LandingSiteBodyDynamicZone']>>> };
  LandingSiteBodyDynamicZone: ResolversUnionParentTypes['LandingSiteBodyDynamicZone'];
  LandingSiteBodyDynamicZoneInput: Scalars['LandingSiteBodyDynamicZoneInput'];
  LandingSiteEntity: LandingSiteEntity;
  LandingSiteEntityResponse: LandingSiteEntityResponse;
  LandingSiteEntityResponseCollection: LandingSiteEntityResponseCollection;
  LandingSiteFiltersInput: LandingSiteFiltersInput;
  LandingSiteInput: LandingSiteInput;
  LandingSiteRelationResponseCollection: LandingSiteRelationResponseCollection;
  Message: Message;
  MessageEntity: MessageEntity;
  MessageEntityResponse: MessageEntityResponse;
  MessageEntityResponseCollection: MessageEntityResponseCollection;
  MessageFiltersInput: MessageFiltersInput;
  MessageInput: MessageInput;
  MessageRelationResponseCollection: MessageRelationResponseCollection;
  Mutation: {};
  NavigationItem: NavigationItem;
  NavigationItemRelated: ResolversUnionParentTypes['NavigationItemRelated'];
  NavigationItemRelatedData: Omit<NavigationItemRelatedData, 'attributes'> & { attributes?: Maybe<ResolversParentTypes['NavigationItemRelated']> };
  Page: Omit<Page, 'body'> & { body?: Maybe<Array<Maybe<ResolversParentTypes['PageBodyDynamicZone']>>> };
  PageBodyDynamicZone: ResolversUnionParentTypes['PageBodyDynamicZone'];
  PageBodyDynamicZoneInput: Scalars['PageBodyDynamicZoneInput'];
  PageEntity: PageEntity;
  PageEntityResponse: PageEntityResponse;
  PageEntityResponseCollection: PageEntityResponseCollection;
  PageFiltersInput: PageFiltersInput;
  PageInput: PageInput;
  PageRelationResponseCollection: PageRelationResponseCollection;
  Pagination: Pagination;
  PaginationArg: PaginationArg;
  ProductContent: ProductContent;
  ProductContentEntity: ProductContentEntity;
  ProductContentEntityResponse: ProductContentEntityResponse;
  ProductContentEntityResponseCollection: ProductContentEntityResponseCollection;
  ProductContentFiltersInput: ProductContentFiltersInput;
  ProductContentInput: ProductContentInput;
  ProductContentRelationResponseCollection: ProductContentRelationResponseCollection;
  Query: {};
  ResponseCollectionMeta: ResponseCollectionMeta;
  String: Scalars['String'];
  StringFilterInput: StringFilterInput;
  Upload: Scalars['Upload'];
  UploadFile: Omit<UploadFile, 'related'> & { related?: Maybe<Array<Maybe<ResolversParentTypes['GenericMorph']>>> };
  UploadFileEntity: UploadFileEntity;
  UploadFileEntityResponse: UploadFileEntityResponse;
  UploadFileEntityResponseCollection: UploadFileEntityResponseCollection;
  UploadFileFiltersInput: UploadFileFiltersInput;
  UploadFileInput: UploadFileInput;
  UploadFileRelationResponseCollection: UploadFileRelationResponseCollection;
  UploadFolder: UploadFolder;
  UploadFolderEntity: UploadFolderEntity;
  UploadFolderEntityResponse: UploadFolderEntityResponse;
  UploadFolderEntityResponseCollection: UploadFolderEntityResponseCollection;
  UploadFolderFiltersInput: UploadFolderFiltersInput;
  UploadFolderInput: UploadFolderInput;
  UploadFolderRelationResponseCollection: UploadFolderRelationResponseCollection;
  UsersPermissionsCreateRolePayload: UsersPermissionsCreateRolePayload;
  UsersPermissionsDeleteRolePayload: UsersPermissionsDeleteRolePayload;
  UsersPermissionsLoginInput: UsersPermissionsLoginInput;
  UsersPermissionsLoginPayload: UsersPermissionsLoginPayload;
  UsersPermissionsMe: UsersPermissionsMe;
  UsersPermissionsMeRole: UsersPermissionsMeRole;
  UsersPermissionsPasswordPayload: UsersPermissionsPasswordPayload;
  UsersPermissionsPermission: UsersPermissionsPermission;
  UsersPermissionsPermissionEntity: UsersPermissionsPermissionEntity;
  UsersPermissionsPermissionFiltersInput: UsersPermissionsPermissionFiltersInput;
  UsersPermissionsPermissionRelationResponseCollection: UsersPermissionsPermissionRelationResponseCollection;
  UsersPermissionsRegisterInput: UsersPermissionsRegisterInput;
  UsersPermissionsRole: UsersPermissionsRole;
  UsersPermissionsRoleEntity: UsersPermissionsRoleEntity;
  UsersPermissionsRoleEntityResponse: UsersPermissionsRoleEntityResponse;
  UsersPermissionsRoleEntityResponseCollection: UsersPermissionsRoleEntityResponseCollection;
  UsersPermissionsRoleFiltersInput: UsersPermissionsRoleFiltersInput;
  UsersPermissionsRoleInput: UsersPermissionsRoleInput;
  UsersPermissionsUpdateRolePayload: UsersPermissionsUpdateRolePayload;
  UsersPermissionsUser: UsersPermissionsUser;
  UsersPermissionsUserEntity: UsersPermissionsUserEntity;
  UsersPermissionsUserEntityResponse: UsersPermissionsUserEntityResponse;
  UsersPermissionsUserEntityResponseCollection: UsersPermissionsUserEntityResponseCollection;
  UsersPermissionsUserFiltersInput: UsersPermissionsUserFiltersInput;
  UsersPermissionsUserInput: UsersPermissionsUserInput;
  UsersPermissionsUserRelationResponseCollection: UsersPermissionsUserRelationResponseCollection;
};

export type CategoryContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContent'] = ResolversParentTypes['CategoryContent']> = {
  body?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryContentBodyDynamicZone']>>>, ParentType, ContextType>;
  categoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizations?: Resolver<Maybe<ResolversTypes['CategoryContentRelationResponseCollection']>, ParentType, ContextType, RequireFields<CategoryContentLocalizationsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryContentBodyDynamicZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContentBodyDynamicZone'] = ResolversParentTypes['CategoryContentBodyDynamicZone']> = {
  __resolveType: TypeResolveFn<'ComponentBasicBlockS1Banner' | 'ComponentBasicBlockS3SingleProduct' | 'ComponentBasicBlockS4ProductList' | 'ComponentSectionsCz10Accordion' | 'ComponentSectionsCz11Cta' | 'ComponentSectionsCz12TextBlock' | 'ComponentSectionsCz13ImageWithText' | 'ComponentSectionsCz14ImageGallery' | 'ComponentSectionsCz15Article' | 'ComponentSectionsCz16Features' | 'ComponentSectionsCzAboutUs' | 'ComponentSectionsS55Form' | 'Error', ParentType, ContextType>;
};

export interface CategoryContentBodyDynamicZoneInputScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CategoryContentBodyDynamicZoneInput'], any> {
  name: 'CategoryContentBodyDynamicZoneInput';
}

export type CategoryContentEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContentEntity'] = ResolversParentTypes['CategoryContentEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['CategoryContent']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryContentEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContentEntityResponse'] = ResolversParentTypes['CategoryContentEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['CategoryContentEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryContentEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContentEntityResponseCollection'] = ResolversParentTypes['CategoryContentEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['CategoryContentEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryContentRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryContentRelationResponseCollection'] = ResolversParentTypes['CategoryContentRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['CategoryContentEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentBasicBlockS1BannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentBasicBlockS1Banner'] = ResolversParentTypes['ComponentBasicBlockS1Banner']> = {
  buttonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  targetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentBasicBlockS3SingleProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentBasicBlockS3SingleProduct'] = ResolversParentTypes['ComponentBasicBlockS3SingleProduct']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentBasicBlockS4ProductListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentBasicBlockS4ProductList'] = ResolversParentTypes['ComponentBasicBlockS4ProductList']> = {
  Products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentBasicBlockS3SingleProduct']>>>, ParentType, ContextType, RequireFields<ComponentBasicBlockS4ProductListProductsArgs, 'pagination' | 'sort'>>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesAboutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesAboutItem'] = ResolversParentTypes['ComponentModulesAboutItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['UploadFileRelationResponseCollection']>, ParentType, ContextType, RequireFields<ComponentModulesAboutItemImageArgs, 'pagination' | 'sort'>>;
  imageAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageMobile?: Resolver<Maybe<ResolversTypes['UploadFileRelationResponseCollection']>, ParentType, ContextType, RequireFields<ComponentModulesAboutItemImageMobileArgs, 'pagination' | 'sort'>>;
  imageTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesAccordionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesAccordionItem'] = ResolversParentTypes['ComponentModulesAccordionItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesCtaItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesCtaItem'] = ResolversParentTypes['ComponentModulesCtaItem']> = {
  buttonTargetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buttonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  iconAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesFeatItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesFeatItem'] = ResolversParentTypes['ComponentModulesFeatItem']> = {
  icon?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesFormItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesFormItem'] = ResolversParentTypes['ComponentModulesFormItem']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputType?: Resolver<Maybe<ResolversTypes['ENUM_COMPONENTMODULESFORMITEM_INPUTTYPE']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesGalleryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesGalleryItem'] = ResolversParentTypes['ComponentModulesGalleryItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['UploadFileEntityResponse'], ParentType, ContextType>;
  imageAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageMobile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  imageTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkTargetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  linkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentModulesImageTextItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentModulesImageTextItem'] = ResolversParentTypes['ComponentModulesImageTextItem']> = {
  alignment?: Resolver<Maybe<ResolversTypes['ENUM_COMPONENTMODULESIMAGETEXTITEM_ALIGNMENT']>, ParentType, ContextType>;
  buttonTargetBlank?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buttonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['UploadFileEntityResponse'], ParentType, ContextType>;
  imageAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageMobile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz10AccordionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz10Accordion'] = ResolversParentTypes['ComponentSectionsCz10Accordion']> = {
  accordionItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesAccordionItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCz10AccordionAccordionItemArgs, 'pagination' | 'sort'>>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz11CtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz11Cta'] = ResolversParentTypes['ComponentSectionsCz11Cta']> = {
  ctaItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesCtaItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCz11CtaCtaItemArgs, 'pagination' | 'sort'>>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz12TextBlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz12TextBlock'] = ResolversParentTypes['ComponentSectionsCz12TextBlock']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz13ImageWithTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz13ImageWithText'] = ResolversParentTypes['ComponentSectionsCz13ImageWithText']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageTextItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesImageTextItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCz13ImageWithTextImageTextItemArgs, 'pagination' | 'sort'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz14ImageGalleryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz14ImageGallery'] = ResolversParentTypes['ComponentSectionsCz14ImageGallery']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  galleryItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesGalleryItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCz14ImageGalleryGalleryItemArgs, 'pagination' | 'sort'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz15ArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz15Article'] = ResolversParentTypes['ComponentSectionsCz15Article']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  imageMobile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCz16FeaturesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCz16Features'] = ResolversParentTypes['ComponentSectionsCz16Features']> = {
  FeatItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesFeatItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCz16FeaturesFeatItemArgs, 'pagination' | 'sort'>>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsCzAboutUsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsCzAboutUs'] = ResolversParentTypes['ComponentSectionsCzAboutUs']> = {
  AboutItem?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesAboutItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsCzAboutUsAboutItemArgs, 'pagination' | 'sort'>>;
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentSectionsS55FormResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentSectionsS55Form'] = ResolversParentTypes['ComponentSectionsS55Form']> = {
  customerGroups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  emailRecipients?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComponentModulesFormItem']>>>, ParentType, ContextType, RequireFields<ComponentSectionsS55FormFieldsArgs, 'pagination' | 'sort'>>;
  formName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  submitText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type ErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericMorphResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericMorph'] = ResolversParentTypes['GenericMorph']> = {
  __resolveType: TypeResolveFn<'CategoryContent' | 'ComponentBasicBlockS1Banner' | 'ComponentBasicBlockS3SingleProduct' | 'ComponentBasicBlockS4ProductList' | 'ComponentModulesAboutItem' | 'ComponentModulesAccordionItem' | 'ComponentModulesCtaItem' | 'ComponentModulesFeatItem' | 'ComponentModulesFormItem' | 'ComponentModulesGalleryItem' | 'ComponentModulesImageTextItem' | 'ComponentSectionsCz10Accordion' | 'ComponentSectionsCz11Cta' | 'ComponentSectionsCz12TextBlock' | 'ComponentSectionsCz13ImageWithText' | 'ComponentSectionsCz14ImageGallery' | 'ComponentSectionsCz15Article' | 'ComponentSectionsCz16Features' | 'ComponentSectionsCzAboutUs' | 'ComponentSectionsS55Form' | 'I18NLocale' | 'LandingSite' | 'Message' | 'Page' | 'ProductContent' | 'UploadFile' | 'UploadFolder' | 'UsersPermissionsPermission' | 'UsersPermissionsRole' | 'UsersPermissionsUser', ParentType, ContextType>;
};

export type I18NLocaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['I18NLocale'] = ResolversParentTypes['I18NLocale']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface I18NLocaleCodeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['I18NLocaleCode'], any> {
  name: 'I18NLocaleCode';
}

export type I18NLocaleEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['I18NLocaleEntity'] = ResolversParentTypes['I18NLocaleEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['I18NLocale']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type I18NLocaleEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['I18NLocaleEntityResponse'] = ResolversParentTypes['I18NLocaleEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['I18NLocaleEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type I18NLocaleEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['I18NLocaleEntityResponseCollection'] = ResolversParentTypes['I18NLocaleEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['I18NLocaleEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LandingSiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSite'] = ResolversParentTypes['LandingSite']> = {
  body?: Resolver<Maybe<Array<Maybe<ResolversTypes['LandingSiteBodyDynamicZone']>>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizations?: Resolver<Maybe<ResolversTypes['LandingSiteRelationResponseCollection']>, ParentType, ContextType, RequireFields<LandingSiteLocalizationsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LandingSiteBodyDynamicZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSiteBodyDynamicZone'] = ResolversParentTypes['LandingSiteBodyDynamicZone']> = {
  __resolveType: TypeResolveFn<'ComponentBasicBlockS1Banner' | 'ComponentBasicBlockS3SingleProduct' | 'ComponentBasicBlockS4ProductList' | 'ComponentSectionsCz10Accordion' | 'ComponentSectionsCz11Cta' | 'ComponentSectionsCz12TextBlock' | 'ComponentSectionsCz13ImageWithText' | 'ComponentSectionsCz14ImageGallery' | 'ComponentSectionsCz15Article' | 'ComponentSectionsCz16Features' | 'ComponentSectionsCzAboutUs' | 'ComponentSectionsS55Form' | 'Error', ParentType, ContextType>;
};

export interface LandingSiteBodyDynamicZoneInputScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LandingSiteBodyDynamicZoneInput'], any> {
  name: 'LandingSiteBodyDynamicZoneInput';
}

export type LandingSiteEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSiteEntity'] = ResolversParentTypes['LandingSiteEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['LandingSite']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LandingSiteEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSiteEntityResponse'] = ResolversParentTypes['LandingSiteEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['LandingSiteEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LandingSiteEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSiteEntityResponseCollection'] = ResolversParentTypes['LandingSiteEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['LandingSiteEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LandingSiteRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LandingSiteRelationResponseCollection'] = ResolversParentTypes['LandingSiteRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['LandingSiteEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizations?: Resolver<Maybe<ResolversTypes['MessageRelationResponseCollection']>, ParentType, ContextType, RequireFields<MessageLocalizationsArgs, 'pagination' | 'sort'>>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEntity'] = ResolversParentTypes['MessageEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEntityResponse'] = ResolversParentTypes['MessageEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEntityResponseCollection'] = ResolversParentTypes['MessageEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['MessageEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageRelationResponseCollection'] = ResolversParentTypes['MessageRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['MessageEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  changePassword?: Resolver<Maybe<ResolversTypes['UsersPermissionsLoginPayload']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'currentPassword' | 'password' | 'passwordConfirmation'>>;
  createCategoryContent?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateCategoryContentArgs, 'data'>>;
  createCategoryContentLocalization?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponse']>, ParentType, ContextType, Partial<MutationCreateCategoryContentLocalizationArgs>>;
  createLandingSite?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateLandingSiteArgs, 'data'>>;
  createLandingSiteLocalization?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponse']>, ParentType, ContextType, Partial<MutationCreateLandingSiteLocalizationArgs>>;
  createMessage?: Resolver<Maybe<ResolversTypes['MessageEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateMessageArgs, 'data'>>;
  createMessageLocalization?: Resolver<Maybe<ResolversTypes['MessageEntityResponse']>, ParentType, ContextType, Partial<MutationCreateMessageLocalizationArgs>>;
  createPage?: Resolver<Maybe<ResolversTypes['PageEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreatePageArgs, 'data'>>;
  createPageLocalization?: Resolver<Maybe<ResolversTypes['PageEntityResponse']>, ParentType, ContextType, Partial<MutationCreatePageLocalizationArgs>>;
  createProductContent?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateProductContentArgs, 'data'>>;
  createProductContentLocalization?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponse']>, ParentType, ContextType, Partial<MutationCreateProductContentLocalizationArgs>>;
  createUploadFile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateUploadFileArgs, 'data'>>;
  createUploadFolder?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponse']>, ParentType, ContextType, RequireFields<MutationCreateUploadFolderArgs, 'data'>>;
  createUsersPermissionsRole?: Resolver<Maybe<ResolversTypes['UsersPermissionsCreateRolePayload']>, ParentType, ContextType, RequireFields<MutationCreateUsersPermissionsRoleArgs, 'data'>>;
  createUsersPermissionsUser?: Resolver<ResolversTypes['UsersPermissionsUserEntityResponse'], ParentType, ContextType, RequireFields<MutationCreateUsersPermissionsUserArgs, 'data'>>;
  deleteCategoryContent?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteCategoryContentArgs, 'id'>>;
  deleteLandingSite?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteLandingSiteArgs, 'id'>>;
  deleteMessage?: Resolver<Maybe<ResolversTypes['MessageEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteMessageArgs, 'id'>>;
  deletePage?: Resolver<Maybe<ResolversTypes['PageEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeletePageArgs, 'id'>>;
  deleteProductContent?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteProductContentArgs, 'id'>>;
  deleteUploadFile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteUploadFileArgs, 'id'>>;
  deleteUploadFolder?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponse']>, ParentType, ContextType, RequireFields<MutationDeleteUploadFolderArgs, 'id'>>;
  deleteUsersPermissionsRole?: Resolver<Maybe<ResolversTypes['UsersPermissionsDeleteRolePayload']>, ParentType, ContextType, RequireFields<MutationDeleteUsersPermissionsRoleArgs, 'id'>>;
  deleteUsersPermissionsUser?: Resolver<ResolversTypes['UsersPermissionsUserEntityResponse'], ParentType, ContextType, RequireFields<MutationDeleteUsersPermissionsUserArgs, 'id'>>;
  emailConfirmation?: Resolver<Maybe<ResolversTypes['UsersPermissionsLoginPayload']>, ParentType, ContextType, RequireFields<MutationEmailConfirmationArgs, 'confirmation'>>;
  forgotPassword?: Resolver<Maybe<ResolversTypes['UsersPermissionsPasswordPayload']>, ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'email'>>;
  login?: Resolver<ResolversTypes['UsersPermissionsLoginPayload'], ParentType, ContextType, RequireFields<MutationLoginArgs, 'input'>>;
  multipleUpload?: Resolver<Array<Maybe<ResolversTypes['UploadFileEntityResponse']>>, ParentType, ContextType, RequireFields<MutationMultipleUploadArgs, 'files'>>;
  register?: Resolver<ResolversTypes['UsersPermissionsLoginPayload'], ParentType, ContextType, RequireFields<MutationRegisterArgs, 'input'>>;
  removeFile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType, RequireFields<MutationRemoveFileArgs, 'id'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['UsersPermissionsLoginPayload']>, ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'code' | 'password' | 'passwordConfirmation'>>;
  updateCategoryContent?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateCategoryContentArgs, 'data' | 'id'>>;
  updateFileInfo?: Resolver<ResolversTypes['UploadFileEntityResponse'], ParentType, ContextType, RequireFields<MutationUpdateFileInfoArgs, 'id'>>;
  updateLandingSite?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateLandingSiteArgs, 'data' | 'id'>>;
  updateMessage?: Resolver<Maybe<ResolversTypes['MessageEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateMessageArgs, 'data' | 'id'>>;
  updatePage?: Resolver<Maybe<ResolversTypes['PageEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdatePageArgs, 'data' | 'id'>>;
  updateProductContent?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateProductContentArgs, 'data' | 'id'>>;
  updateUploadFile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUploadFileArgs, 'data' | 'id'>>;
  updateUploadFolder?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUploadFolderArgs, 'data' | 'id'>>;
  updateUsersPermissionsRole?: Resolver<Maybe<ResolversTypes['UsersPermissionsUpdateRolePayload']>, ParentType, ContextType, RequireFields<MutationUpdateUsersPermissionsRoleArgs, 'data' | 'id'>>;
  updateUsersPermissionsUser?: Resolver<ResolversTypes['UsersPermissionsUserEntityResponse'], ParentType, ContextType, RequireFields<MutationUpdateUsersPermissionsUserArgs, 'data' | 'id'>>;
  upload?: Resolver<ResolversTypes['UploadFileEntityResponse'], ParentType, ContextType, RequireFields<MutationUploadArgs, 'file'>>;
};

export type NavigationItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavigationItem'] = ResolversParentTypes['NavigationItem']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['NavigationItem']>>>, ParentType, ContextType>;
  master?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  menuAttached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['NavigationItem']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  related?: Resolver<Maybe<ResolversTypes['NavigationItemRelatedData']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uiRouterKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NavigationItemRelatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavigationItemRelated'] = ResolversParentTypes['NavigationItemRelated']> = {
  __resolveType: TypeResolveFn<'LandingSite', ParentType, ContextType>;
};

export type NavigationItemRelatedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavigationItemRelatedData'] = ResolversParentTypes['NavigationItemRelatedData']> = {
  attributes?: Resolver<Maybe<ResolversTypes['NavigationItemRelated']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = {
  body?: Resolver<Maybe<Array<Maybe<ResolversTypes['PageBodyDynamicZone']>>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizations?: Resolver<Maybe<ResolversTypes['PageRelationResponseCollection']>, ParentType, ContextType, RequireFields<PageLocalizationsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageBodyDynamicZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageBodyDynamicZone'] = ResolversParentTypes['PageBodyDynamicZone']> = {
  __resolveType: TypeResolveFn<'ComponentBasicBlockS1Banner' | 'ComponentBasicBlockS3SingleProduct' | 'ComponentBasicBlockS4ProductList' | 'ComponentSectionsCz10Accordion' | 'ComponentSectionsCz11Cta' | 'ComponentSectionsCz12TextBlock' | 'ComponentSectionsCz13ImageWithText' | 'ComponentSectionsCz14ImageGallery' | 'ComponentSectionsCz15Article' | 'ComponentSectionsCz16Features' | 'ComponentSectionsCzAboutUs' | 'ComponentSectionsS55Form' | 'Error', ParentType, ContextType>;
};

export interface PageBodyDynamicZoneInputScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PageBodyDynamicZoneInput'], any> {
  name: 'PageBodyDynamicZoneInput';
}

export type PageEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageEntity'] = ResolversParentTypes['PageEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageEntityResponse'] = ResolversParentTypes['PageEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['PageEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageEntityResponseCollection'] = ResolversParentTypes['PageEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['PageEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageRelationResponseCollection'] = ResolversParentTypes['PageRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['PageEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pagination'] = ResolversParentTypes['Pagination']> = {
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductContent'] = ResolversParentTypes['ProductContent']> = {
  banner?: Resolver<Maybe<ResolversTypes['ComponentBasicBlockS1Banner']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['ComponentBasicBlockS1Banner']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizations?: Resolver<Maybe<ResolversTypes['ProductContentRelationResponseCollection']>, ParentType, ContextType, RequireFields<ProductContentLocalizationsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductContentEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductContentEntity'] = ResolversParentTypes['ProductContentEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['ProductContent']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductContentEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductContentEntityResponse'] = ResolversParentTypes['ProductContentEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['ProductContentEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductContentEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductContentEntityResponseCollection'] = ResolversParentTypes['ProductContentEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['ProductContentEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductContentRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductContentRelationResponseCollection'] = ResolversParentTypes['ProductContentRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['ProductContentEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  categoryContent?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponse']>, ParentType, ContextType, Partial<QueryCategoryContentArgs>>;
  categoryContents?: Resolver<Maybe<ResolversTypes['CategoryContentEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryCategoryContentsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  i18NLocale?: Resolver<Maybe<ResolversTypes['I18NLocaleEntityResponse']>, ParentType, ContextType, Partial<QueryI18NLocaleArgs>>;
  i18NLocales?: Resolver<Maybe<ResolversTypes['I18NLocaleEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryI18NLocalesArgs, 'pagination' | 'sort'>>;
  landingSite?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponse']>, ParentType, ContextType, Partial<QueryLandingSiteArgs>>;
  landingSites?: Resolver<Maybe<ResolversTypes['LandingSiteEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryLandingSitesArgs, 'pagination' | 'publicationState' | 'sort'>>;
  me?: Resolver<Maybe<ResolversTypes['UsersPermissionsMe']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['MessageEntityResponse']>, ParentType, ContextType, Partial<QueryMessageArgs>>;
  messages?: Resolver<Maybe<ResolversTypes['MessageEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryMessagesArgs, 'pagination' | 'sort'>>;
  page?: Resolver<Maybe<ResolversTypes['PageEntityResponse']>, ParentType, ContextType, Partial<QueryPageArgs>>;
  pages?: Resolver<Maybe<ResolversTypes['PageEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryPagesArgs, 'pagination' | 'publicationState' | 'sort'>>;
  productContent?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponse']>, ParentType, ContextType, Partial<QueryProductContentArgs>>;
  productContents?: Resolver<Maybe<ResolversTypes['ProductContentEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryProductContentsArgs, 'pagination' | 'publicationState' | 'sort'>>;
  renderNavigation?: Resolver<Array<Maybe<ResolversTypes['NavigationItem']>>, ParentType, ContextType, RequireFields<QueryRenderNavigationArgs, 'navigationIdOrSlug'>>;
  renderNavigationChild?: Resolver<Array<Maybe<ResolversTypes['NavigationItem']>>, ParentType, ContextType, RequireFields<QueryRenderNavigationChildArgs, 'childUiKey' | 'id'>>;
  uploadFile?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponse']>, ParentType, ContextType, Partial<QueryUploadFileArgs>>;
  uploadFiles?: Resolver<Maybe<ResolversTypes['UploadFileEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryUploadFilesArgs, 'pagination' | 'sort'>>;
  uploadFolder?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponse']>, ParentType, ContextType, Partial<QueryUploadFolderArgs>>;
  uploadFolders?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryUploadFoldersArgs, 'pagination' | 'sort'>>;
  usersPermissionsRole?: Resolver<Maybe<ResolversTypes['UsersPermissionsRoleEntityResponse']>, ParentType, ContextType, Partial<QueryUsersPermissionsRoleArgs>>;
  usersPermissionsRoles?: Resolver<Maybe<ResolversTypes['UsersPermissionsRoleEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryUsersPermissionsRolesArgs, 'pagination' | 'sort'>>;
  usersPermissionsUser?: Resolver<Maybe<ResolversTypes['UsersPermissionsUserEntityResponse']>, ParentType, ContextType, Partial<QueryUsersPermissionsUserArgs>>;
  usersPermissionsUsers?: Resolver<Maybe<ResolversTypes['UsersPermissionsUserEntityResponseCollection']>, ParentType, ContextType, RequireFields<QueryUsersPermissionsUsersArgs, 'pagination' | 'sort'>>;
};

export type ResponseCollectionMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResponseCollectionMeta'] = ResolversParentTypes['ResponseCollectionMeta']> = {
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UploadFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFile'] = ResolversParentTypes['UploadFile']> = {
  alternativeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  ext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formats?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previewUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provider_metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  related?: Resolver<Maybe<Array<Maybe<ResolversTypes['GenericMorph']>>>, ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFileEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFileEntity'] = ResolversParentTypes['UploadFileEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['UploadFile']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFileEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFileEntityResponse'] = ResolversParentTypes['UploadFileEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['UploadFileEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFileEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFileEntityResponseCollection'] = ResolversParentTypes['UploadFileEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UploadFileEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFileRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFileRelationResponseCollection'] = ResolversParentTypes['UploadFileRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UploadFileEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFolder'] = ResolversParentTypes['UploadFolder']> = {
  children?: Resolver<Maybe<ResolversTypes['UploadFolderRelationResponseCollection']>, ParentType, ContextType, RequireFields<UploadFolderChildrenArgs, 'pagination' | 'sort'>>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['UploadFileRelationResponseCollection']>, ParentType, ContextType, RequireFields<UploadFolderFilesArgs, 'pagination' | 'sort'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['UploadFolderEntityResponse']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pathId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFolderEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFolderEntity'] = ResolversParentTypes['UploadFolderEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['UploadFolder']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFolderEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFolderEntityResponse'] = ResolversParentTypes['UploadFolderEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['UploadFolderEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFolderEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFolderEntityResponseCollection'] = ResolversParentTypes['UploadFolderEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UploadFolderEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFolderRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFolderRelationResponseCollection'] = ResolversParentTypes['UploadFolderRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UploadFolderEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsCreateRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsCreateRolePayload'] = ResolversParentTypes['UsersPermissionsCreateRolePayload']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsDeleteRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsDeleteRolePayload'] = ResolversParentTypes['UsersPermissionsDeleteRolePayload']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsLoginPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsLoginPayload'] = ResolversParentTypes['UsersPermissionsLoginPayload']> = {
  jwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UsersPermissionsMe'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsMeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsMe'] = ResolversParentTypes['UsersPermissionsMe']> = {
  blocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  confirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['UsersPermissionsMeRole']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsMeRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsMeRole'] = ResolversParentTypes['UsersPermissionsMeRole']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsPasswordPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsPasswordPayload'] = ResolversParentTypes['UsersPermissionsPasswordPayload']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsPermission'] = ResolversParentTypes['UsersPermissionsPermission']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['UsersPermissionsRoleEntityResponse']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsPermissionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsPermissionEntity'] = ResolversParentTypes['UsersPermissionsPermissionEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['UsersPermissionsPermission']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsPermissionRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsPermissionRelationResponseCollection'] = ResolversParentTypes['UsersPermissionsPermissionRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UsersPermissionsPermissionEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsRole'] = ResolversParentTypes['UsersPermissionsRole']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['UsersPermissionsPermissionRelationResponseCollection']>, ParentType, ContextType, RequireFields<UsersPermissionsRolePermissionsArgs, 'pagination' | 'sort'>>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  users?: Resolver<Maybe<ResolversTypes['UsersPermissionsUserRelationResponseCollection']>, ParentType, ContextType, RequireFields<UsersPermissionsRoleUsersArgs, 'pagination' | 'sort'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsRoleEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsRoleEntity'] = ResolversParentTypes['UsersPermissionsRoleEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['UsersPermissionsRole']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsRoleEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsRoleEntityResponse'] = ResolversParentTypes['UsersPermissionsRoleEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['UsersPermissionsRoleEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsRoleEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsRoleEntityResponseCollection'] = ResolversParentTypes['UsersPermissionsRoleEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UsersPermissionsRoleEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUpdateRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUpdateRolePayload'] = ResolversParentTypes['UsersPermissionsUpdateRolePayload']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUser'] = ResolversParentTypes['UsersPermissionsUser']> = {
  blocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  confirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['UsersPermissionsRoleEntityResponse']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUserEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUserEntity'] = ResolversParentTypes['UsersPermissionsUserEntity']> = {
  attributes?: Resolver<Maybe<ResolversTypes['UsersPermissionsUser']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUserEntityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUserEntityResponse'] = ResolversParentTypes['UsersPermissionsUserEntityResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['UsersPermissionsUserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUserEntityResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUserEntityResponseCollection'] = ResolversParentTypes['UsersPermissionsUserEntityResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UsersPermissionsUserEntity']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['ResponseCollectionMeta'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersPermissionsUserRelationResponseCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPermissionsUserRelationResponseCollection'] = ResolversParentTypes['UsersPermissionsUserRelationResponseCollection']> = {
  data?: Resolver<Array<ResolversTypes['UsersPermissionsUserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  CategoryContent?: CategoryContentResolvers<ContextType>;
  CategoryContentBodyDynamicZone?: CategoryContentBodyDynamicZoneResolvers<ContextType>;
  CategoryContentBodyDynamicZoneInput?: GraphQLScalarType;
  CategoryContentEntity?: CategoryContentEntityResolvers<ContextType>;
  CategoryContentEntityResponse?: CategoryContentEntityResponseResolvers<ContextType>;
  CategoryContentEntityResponseCollection?: CategoryContentEntityResponseCollectionResolvers<ContextType>;
  CategoryContentRelationResponseCollection?: CategoryContentRelationResponseCollectionResolvers<ContextType>;
  ComponentBasicBlockS1Banner?: ComponentBasicBlockS1BannerResolvers<ContextType>;
  ComponentBasicBlockS3SingleProduct?: ComponentBasicBlockS3SingleProductResolvers<ContextType>;
  ComponentBasicBlockS4ProductList?: ComponentBasicBlockS4ProductListResolvers<ContextType>;
  ComponentModulesAboutItem?: ComponentModulesAboutItemResolvers<ContextType>;
  ComponentModulesAccordionItem?: ComponentModulesAccordionItemResolvers<ContextType>;
  ComponentModulesCtaItem?: ComponentModulesCtaItemResolvers<ContextType>;
  ComponentModulesFeatItem?: ComponentModulesFeatItemResolvers<ContextType>;
  ComponentModulesFormItem?: ComponentModulesFormItemResolvers<ContextType>;
  ComponentModulesGalleryItem?: ComponentModulesGalleryItemResolvers<ContextType>;
  ComponentModulesImageTextItem?: ComponentModulesImageTextItemResolvers<ContextType>;
  ComponentSectionsCz10Accordion?: ComponentSectionsCz10AccordionResolvers<ContextType>;
  ComponentSectionsCz11Cta?: ComponentSectionsCz11CtaResolvers<ContextType>;
  ComponentSectionsCz12TextBlock?: ComponentSectionsCz12TextBlockResolvers<ContextType>;
  ComponentSectionsCz13ImageWithText?: ComponentSectionsCz13ImageWithTextResolvers<ContextType>;
  ComponentSectionsCz14ImageGallery?: ComponentSectionsCz14ImageGalleryResolvers<ContextType>;
  ComponentSectionsCz15Article?: ComponentSectionsCz15ArticleResolvers<ContextType>;
  ComponentSectionsCz16Features?: ComponentSectionsCz16FeaturesResolvers<ContextType>;
  ComponentSectionsCzAboutUs?: ComponentSectionsCzAboutUsResolvers<ContextType>;
  ComponentSectionsS55Form?: ComponentSectionsS55FormResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Error?: ErrorResolvers<ContextType>;
  GenericMorph?: GenericMorphResolvers<ContextType>;
  I18NLocale?: I18NLocaleResolvers<ContextType>;
  I18NLocaleCode?: GraphQLScalarType;
  I18NLocaleEntity?: I18NLocaleEntityResolvers<ContextType>;
  I18NLocaleEntityResponse?: I18NLocaleEntityResponseResolvers<ContextType>;
  I18NLocaleEntityResponseCollection?: I18NLocaleEntityResponseCollectionResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LandingSite?: LandingSiteResolvers<ContextType>;
  LandingSiteBodyDynamicZone?: LandingSiteBodyDynamicZoneResolvers<ContextType>;
  LandingSiteBodyDynamicZoneInput?: GraphQLScalarType;
  LandingSiteEntity?: LandingSiteEntityResolvers<ContextType>;
  LandingSiteEntityResponse?: LandingSiteEntityResponseResolvers<ContextType>;
  LandingSiteEntityResponseCollection?: LandingSiteEntityResponseCollectionResolvers<ContextType>;
  LandingSiteRelationResponseCollection?: LandingSiteRelationResponseCollectionResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageEntity?: MessageEntityResolvers<ContextType>;
  MessageEntityResponse?: MessageEntityResponseResolvers<ContextType>;
  MessageEntityResponseCollection?: MessageEntityResponseCollectionResolvers<ContextType>;
  MessageRelationResponseCollection?: MessageRelationResponseCollectionResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NavigationItem?: NavigationItemResolvers<ContextType>;
  NavigationItemRelated?: NavigationItemRelatedResolvers<ContextType>;
  NavigationItemRelatedData?: NavigationItemRelatedDataResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageBodyDynamicZone?: PageBodyDynamicZoneResolvers<ContextType>;
  PageBodyDynamicZoneInput?: GraphQLScalarType;
  PageEntity?: PageEntityResolvers<ContextType>;
  PageEntityResponse?: PageEntityResponseResolvers<ContextType>;
  PageEntityResponseCollection?: PageEntityResponseCollectionResolvers<ContextType>;
  PageRelationResponseCollection?: PageRelationResponseCollectionResolvers<ContextType>;
  Pagination?: PaginationResolvers<ContextType>;
  ProductContent?: ProductContentResolvers<ContextType>;
  ProductContentEntity?: ProductContentEntityResolvers<ContextType>;
  ProductContentEntityResponse?: ProductContentEntityResponseResolvers<ContextType>;
  ProductContentEntityResponseCollection?: ProductContentEntityResponseCollectionResolvers<ContextType>;
  ProductContentRelationResponseCollection?: ProductContentRelationResponseCollectionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ResponseCollectionMeta?: ResponseCollectionMetaResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UploadFile?: UploadFileResolvers<ContextType>;
  UploadFileEntity?: UploadFileEntityResolvers<ContextType>;
  UploadFileEntityResponse?: UploadFileEntityResponseResolvers<ContextType>;
  UploadFileEntityResponseCollection?: UploadFileEntityResponseCollectionResolvers<ContextType>;
  UploadFileRelationResponseCollection?: UploadFileRelationResponseCollectionResolvers<ContextType>;
  UploadFolder?: UploadFolderResolvers<ContextType>;
  UploadFolderEntity?: UploadFolderEntityResolvers<ContextType>;
  UploadFolderEntityResponse?: UploadFolderEntityResponseResolvers<ContextType>;
  UploadFolderEntityResponseCollection?: UploadFolderEntityResponseCollectionResolvers<ContextType>;
  UploadFolderRelationResponseCollection?: UploadFolderRelationResponseCollectionResolvers<ContextType>;
  UsersPermissionsCreateRolePayload?: UsersPermissionsCreateRolePayloadResolvers<ContextType>;
  UsersPermissionsDeleteRolePayload?: UsersPermissionsDeleteRolePayloadResolvers<ContextType>;
  UsersPermissionsLoginPayload?: UsersPermissionsLoginPayloadResolvers<ContextType>;
  UsersPermissionsMe?: UsersPermissionsMeResolvers<ContextType>;
  UsersPermissionsMeRole?: UsersPermissionsMeRoleResolvers<ContextType>;
  UsersPermissionsPasswordPayload?: UsersPermissionsPasswordPayloadResolvers<ContextType>;
  UsersPermissionsPermission?: UsersPermissionsPermissionResolvers<ContextType>;
  UsersPermissionsPermissionEntity?: UsersPermissionsPermissionEntityResolvers<ContextType>;
  UsersPermissionsPermissionRelationResponseCollection?: UsersPermissionsPermissionRelationResponseCollectionResolvers<ContextType>;
  UsersPermissionsRole?: UsersPermissionsRoleResolvers<ContextType>;
  UsersPermissionsRoleEntity?: UsersPermissionsRoleEntityResolvers<ContextType>;
  UsersPermissionsRoleEntityResponse?: UsersPermissionsRoleEntityResponseResolvers<ContextType>;
  UsersPermissionsRoleEntityResponseCollection?: UsersPermissionsRoleEntityResponseCollectionResolvers<ContextType>;
  UsersPermissionsUpdateRolePayload?: UsersPermissionsUpdateRolePayloadResolvers<ContextType>;
  UsersPermissionsUser?: UsersPermissionsUserResolvers<ContextType>;
  UsersPermissionsUserEntity?: UsersPermissionsUserEntityResolvers<ContextType>;
  UsersPermissionsUserEntityResponse?: UsersPermissionsUserEntityResponseResolvers<ContextType>;
  UsersPermissionsUserEntityResponseCollection?: UsersPermissionsUserEntityResponseCollectionResolvers<ContextType>;
  UsersPermissionsUserRelationResponseCollection?: UsersPermissionsUserRelationResponseCollectionResolvers<ContextType>;
};

